import { useAppContext } from '@gplibraries/react/hooks';
export function useDealerSwitch() {
    const [showDealerSwitch, setShowDealerSwitch] = useAppContext('showDealerSwitch', false);
    function switchDealer() {
        if (!showDealerSwitch) {
            setShowDealerSwitch(true);
        }
    }
    return switchDealer;
}
